<script>
    import ProviderObject from '@/components/page-provider-and-game-edit/ProviderObject.vue';

    export default {
        components: {
            ProviderObject: ProviderObject,
        },
        computed: {
            providerAndGame() {return this.$store.getters.PROVIDERS_AND_GAMES}
        }
    }
</script>


<template>
    <ProviderObject 
        v-for="(providerValue, providerIndex) in providerAndGame" :key="providerIndex"
        :provider = "providerValue"
    />
</template>